// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogContent,
//   TextField,
//   Button,
//   MenuItem,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { getStateData } from "./citydata";

// const registerUrl =
//   "https://4xuh6eqvr6.execute-api.ap-south-1.amazonaws.com/production/register";

// const RegisterPopup = ({ open, handleClose }) => {
//   const [registrationData, setRegistrationData] = useState({
//     name: "", 
//     email: "",
//     phone: "",
//     password: "",
//     state: "",
//     city: "",
//     pincode: "",
//     assistedby: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [redirecting, setRedirecting] = useState(false);
//   const [selectedState, setSelectedState] = useState("");
//   const [cities, setCities] = useState([]);
//   const states = Object.keys(getStateData());

//   useEffect(() => {
//     if (selectedState) {
//       setCities(getStateData()[selectedState] || []);
//     } else {
//       setCities([]);
//     }
//   }, [selectedState]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setRegistrationData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     if (name === "state") setSelectedState(value);
//   };

//   const handleSubmit = async () => {
//     // Field validation
//     const requiredFields = [
//       "name",
//       "email",
//       "password",
//       "phone",
//       "state",
//       "city",
//       "pincode",
//     ];

//     const emptyFields = requiredFields.filter(
//       (field) => !registrationData[field]?.trim()
//     );

//     if (emptyFields.length > 0) {
//       alert("Please fill all required fields before signing up.");
//       return;
//     }

//     setLoading(true);

//     const requestBody = {
//       phoneNo: registrationData.phone,
//       name: registrationData.name,
//       email: registrationData.email,
//       state: registrationData.state,
//       city: registrationData.city,
//       pin: registrationData.pincode,
//       assisted: registrationData.assistedby,
//       user: "client",
//       password: registrationData.password,
//     };

//     try {
//       const res = await fetch(registerUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(requestBody),
//       });

//       const result = await res.json();
//       console.log("Register Success:", result);

//       // alert("Registration successful!");
//       setRedirecting(true);
//       setLoading(false);

//       setTimeout(() => {
//         window.location.href = "https://arnxt.com";
//       }, 2500);
//     } catch (err) {
//       console.error("Registration failed:", err);
//       alert("Registration failed. Please try again.");
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//       <DialogContent sx={{ p: 3 }}>
//         <Typography variant="h5" fontWeight="bold" textAlign="center" mb={3}>
//           Sign Up to Explore
//         </Typography>

//         {[
//           { name: "name", label: "Enter Name" },
//           { name: "email", label: "Email Address" },
//           { name: "password", label: "Password", type: "password" },
//           { name: "phone", label: "Mobile No" },
//           { name: "pincode", label: "Pincode" },
//           { name: "assistedby", label: "Ref By (Optional)" },
//         ].map((field) => (
//           <TextField
//             key={field.name}
//             fullWidth
//             margin="dense"
//             name={field.name}
//             label={field.label}
//             type={field.type || "text"}
//             value={registrationData[field.name]}
//             onChange={handleChange}
//             sx={{ "& .MuiInputBase-root": { height: 42 } }}
//           />
//         ))}

//         <TextField
//           select
//           fullWidth
//           margin="dense"
//           name="state"
//           label="Select State"
//           value={registrationData.state}
//           onChange={handleChange}
//           sx={{ "& .MuiInputBase-root": { height: 42 } }}
//         >
//           {states.map((state) => (
//             <MenuItem key={state} value={state}>
//               {state}
//             </MenuItem>
//           ))}
//         </TextField>

//         <TextField
//           select
//           fullWidth
//           margin="dense"
//           name="city"
//           label="Select City"
//           value={registrationData.city}
//           onChange={handleChange}
//           sx={{ "& .MuiInputBase-root": { height: 42 } }}
//         >
//           {cities.map((city) => (
//             <MenuItem key={city} value={city}>
//               {city}
//             </MenuItem>
//           ))}
//         </TextField>

//         <Button
//           fullWidth
//           variant="contained"
//           disabled={loading || redirecting}
//           sx={{ mt: 2, backgroundColor: "#012A38", color: "#fff" }}
//           onClick={handleSubmit}
//         >
//           {loading ? (
//             <CircularProgress size={24} sx={{ color: "#fff" }} />
//           ) : redirecting ? (
//             "Redirecting..."
//           ) : (
//             "Sign Up"
//           )}
//         </Button>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default RegisterPopup;



import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import { getStateData } from "./citydata";

const registerUrl =
  "https://4xuh6eqvr6.execute-api.ap-south-1.amazonaws.com/production/register";

const RegisterPopup = ({ open, handleClose }) => {
  const [registrationData, setRegistrationData] = useState({
    name: "",
    businessname: "",
    state: "",
    city: "",
    pincode: "",
    phone: "",
    email: "",
    password: "",
    website: "",
    businesstype: "",
    category: "",
    assistedby: "",
  });

  const [loading, setLoading] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);

  const states = Object.keys(getStateData());

  useEffect(() => {
    if (selectedState) {
      setCities(getStateData()[selectedState] || []);
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegistrationData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "state") setSelectedState(value);
  };

  const handleSubmit = async () => {
    // Get client IP
let userIP = "";
try {
  const res = await fetch("https://api.ipify.org?format=json");
  const data = await res.json();
  userIP = data.ip || "";
} catch (err) {
  console.warn("IP not fetched, proceeding without IP");
}


    const requiredFields = [
      "name",
      "businessname",
      "state",
      "city",
      "pincode",
      "phone",
      "email",
      "password",
      "businesstype",
      "category",
    ];

    const emptyFields = requiredFields.filter(
      (field) => !registrationData[field]?.trim()
    );

    if (emptyFields.length > 0) {
      alert("Please fill all required fields before signing up.");
      return;
    }

    setLoading(true);

    const requestBody = {
      phoneNo: registrationData.phone,
      name: registrationData.name,
      email: registrationData.email,
      password: registrationData.password,
      state: registrationData.state,
      city: registrationData.city,
      pin: registrationData.pincode,
      assisted: registrationData.assistedby,
      user: "client",
      businessname: registrationData.businessname,
      website: registrationData.website,
      businesstype: registrationData.businesstype,
      category: registrationData.category,
       ip: userIP
    };

    try {
      const res = await fetch(registerUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const result = await res.json();
      console.log("Register Success:", result);

      setRedirecting(true);
      setLoading(false);

      setTimeout(() => {
        window.location.href = "https://arnxt.com";
      }, 2500);
    } catch (err) {
      console.error("Registration failed:", err);
      alert("Registration failed. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight="bold" textAlign="center" mb={3}>
          Sign Up to Explore
        </Typography>

        <TextField
          fullWidth
          margin="dense"
          name="name"
          label="Name"
          value={registrationData.name}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          fullWidth
          margin="dense"
          name="businessname"
          label="Business Name"
          value={registrationData.businessname}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          select
          fullWidth
          margin="dense"
          name="state"
          label="Select State"
          value={registrationData.state}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        >
          {states.map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          margin="dense"
          name="city"
          label="Select City"
          value={registrationData.city}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        >
          {cities.map((city) => (
            <MenuItem key={city} value={city}>
              {city}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          margin="dense"
          name="pincode"
          label="Pin Code"
          value={registrationData.pincode}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          fullWidth
          margin="dense"
          name="phone"
          label="Phone No."
          value={registrationData.phone}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          fullWidth
          margin="dense"
          name="email"
          label="Email"
          value={registrationData.email}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        {/* NEW PASSWORD FIELD */}
        <TextField
          fullWidth
          margin="dense"
          name="password"
          type="password"
          label="Password"
          value={registrationData.password}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          fullWidth
          margin="dense"
          name="website"
          label="Website (Optional)"
          value={registrationData.website}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <TextField
          select
          fullWidth
          margin="dense"
          name="businesstype"
          label="Business Type"
          value={registrationData.businesstype}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        >
          {["Manufacturer", "Importer/Exporter", "Retailer"].map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          margin="dense"
          name="category"
          label="Category"
          value={registrationData.category}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        >
          {[
            "Furniture",
            "Furnishing",
            "Sanitary",
            "Electrical",
            "Electronics",
            "Decorative",
            "Walls",
            "Floors",
            "Rugs & Carpet",
            "Upholstery",
          ].map((cat) => (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          margin="dense"
          name="assistedby"
          label="Referred By (Optional)"
          value={registrationData.assistedby}
          onChange={handleChange}
          sx={{ "& .MuiInputBase-root": { height: 42 } }}
        />

        <Button
          fullWidth
          variant="contained"
          disabled={loading || redirecting}
          sx={{ mt: 2, backgroundColor: "#012A38", color: "#fff" }}
          onClick={handleSubmit}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : redirecting ? (
            "Redirecting..."
          ) : (
            "Sign Up"
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterPopup;
